import React from 'react';
import {
  StoreDetailsSkeletonContainer,
  StoreDetailsSubtitleSkeleton,
  StoreDetailsTitleSkeleton,
} from './style';

const StoreDetailsSkeleton = () => (
  <StoreDetailsSkeletonContainer>
    <StoreDetailsTitleSkeleton animate />
    <StoreDetailsSubtitleSkeleton animate />
  </StoreDetailsSkeletonContainer>
);

export default StoreDetailsSkeleton;
